import { useEffect, useState } from "react";
import { Check, ChevronsUpDown, Building2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { api } from "@/lib/api";

export default function HospitalCombobox({ value, onSelect }) {
  const [open, setOpen] = useState(false);
  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    api.get("/hospitals").then((r) => setHospitals(r.data)).catch(() => {});
  }, []);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid="hospital-combobox"
          className="w-full justify-between rounded-xl border-[#E2E8F0] font-bold text-slate-700"
        >
          <span className="flex items-center gap-2 truncate">
            <Building2 className="h-4 w-4 shrink-0 text-[#0284C7]" />
            <span className="truncate">{value || "Selecciona un hospital…"}</span>
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Buscar hospital o ciudad…" data-testid="hospital-search-input" />
          <CommandList>
            <CommandEmpty>No se encontró el hospital.</CommandEmpty>
            <CommandGroup>
              {hospitals.map((h) => (
                <CommandItem
                  key={h.name}
                  value={`${h.name} ${h.city}`}
                  data-testid={`hospital-option-${h.name}`}
                  onSelect={() => { onSelect(h); setOpen(false); }}
                  className="cursor-pointer"
                >
                  <Check className={cn("mr-2 h-4 w-4", value === h.name ? "opacity-100 text-[#0284C7]" : "opacity-0")} />
                  <div>
                    <div className="text-sm font-bold text-slate-800">{h.name}</div>
                    <div className="text-xs font-semibold text-slate-400">{h.city}</div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
